import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 3.625H8a.38.38 0 0 1-.375-.375c0-.205.17-.375.375-.375h3c.205 0 .375.17.375.375s-.17.375-.375.375m-8 0H1a.38.38 0 0 1-.375-.375c0-.205.17-.375.375-.375h2c.205 0 .375.17.375.375s-.17.375-.375.375"
      fill="white"
    />
    <path
      d="M5 5.375A2.13 2.13 0 0 1 2.875 3.25 2.13 2.13 0 0 1 5 1.125 2.13 2.13 0 0 1 7.125 3.25 2.13 2.13 0 0 1 5 5.375m0-3.5a1.374 1.374 0 1 0-.002 2.748A1.374 1.374 0 0 0 5 1.875m6 7.25H9a.38.38 0 0 1-.375-.375c0-.205.17-.375.375-.375h2c.205 0 .375.17.375.375s-.17.375-.375.375m-7 0H1a.38.38 0 0 1-.375-.375c0-.205.17-.375.375-.375h3c.205 0 .375.17.375.375s-.17.375-.375.375"
      fill="white"
    />
    <path
      d="M7 10.875A2.13 2.13 0 0 1 4.875 8.75 2.13 2.13 0 0 1 7 6.625 2.13 2.13 0 0 1 9.125 8.75 2.13 2.13 0 0 1 7 10.875m0-3.5a1.374 1.374 0 1 0-.002 2.748A1.374 1.374 0 0 0 7 7.375"
      fill="white"
    />
  </svg>
);
export default SVGComponent;
